import React from 'react';
import MaterialTableComponent from './materialTableComponent';
import ExportTable from '../../common/component/ExportTable';
import { dateComponent } from './dateComponent';
import { hydroStatsComponent } from './hydroStatsComponent';
import { renderTableData } from '../../../utils/helpers/module/moduleComponentHelper';
import { indusWarningComponent } from './indusWarningComponent';

function RenderTableDatas({
  module,
  dataDetail,
  history,
  option,
  indicator,
  countIndicator,
  lengthIndicator,
  blackPoint,
  dataTable,
  dataDate,
  prevFilters,
  roles,
  contractLabel,
  updateTableAndMap,
  zoomToPointTrigger
}) {
  let data = [];
  if (module === 'hydro') {
    data = dataDetail;
  }
  const columns: any = renderTableData(module, history, data, zoomToPointTrigger, option, roles);
  const indicatorModule: string | null = window.sessionStorage.getItem('h2s_indicator');

  return (
    <>
      {/* Header */}
      <div>
        <div style={{ float: 'left' }}>
          {/* HYDRO */}
          {hydroStatsComponent(module, {
            indicator: indicator,
            countIndicator: countIndicator,
            lengthIndicator: lengthIndicator,
            blackPoint: blackPoint,
          })}
          {/* DATA DATE */}
          {module !== 'admin-users' && (module !== 'h2s' || indicatorModule !== 'IndicatorTerrain') && dateComponent(module, dataDate)}
          {/* MILIEU */}
          {module === 'milieu' && (
            <div>
              <button
                id='reloadTableAndMap'
                style={{ display: 'none' }}
                onClick={() => {
                  updateTableAndMap(prevFilters);
                }}
              ></button>
            </div>
          )}
        </div>
        {/* EXPORT TABLE */}
        {module !== 'admin-users' && !roles?.includes('collectivity-consult') === true && (
          <div style={{ float: 'right' }}>
            <ExportTable
              data={dataTable}
              type={module}
              contractLabel={contractLabel!}
            />
          </div>
        )}
      </div>
      {/* Table */}
      <MaterialTableComponent columns={columns} rows={dataTable} rowsPerPage={10} />
      {dataTable.length === 1000 && indusWarningComponent(module)}
    </>
  );
}

export default RenderTableDatas;
